import v1seatTrade from './v1seatTrade'

export default {
  v1seatTrade,
}
